import { observer } from 'mobx-react-lite';
import { GridRowParams } from '@mui/x-data-grid-pro';
import { RowViewModel } from '../viewModels/row';
import { TableViewModel } from '../viewModels/table';
import { TableDataGrid, TableDataGridProps } from '../../tableDataGrid';

export type TableProps<
  TData extends object,
  TRowViewModel extends RowViewModel<TData, TTableViewModel>,
  TTableViewModel extends TableViewModel<TData, TRowViewModel>
> = Omit<TableDataGridProps, 'columns' | 'threepointMenu' | 'rows' | 'apiRef'> & {
  viewModel: TTableViewModel;
};

export const Table = observer(
  <
    TData extends object,
    TRowViewModel extends RowViewModel<TData, TTableViewModel>,
    TTableViewModel extends TableViewModel<TData, TRowViewModel>
  >({
    viewModel,
    ...tableProps
  }: TableProps<TData, TRowViewModel, TTableViewModel>) => {
    return (
      <TableDataGrid
        {...tableProps}
        apiRef={viewModel.apiRef}
        rows={viewModel.rows}
        columns={viewModel.buildColDef()}
        onRowDoubleClick={(params: GridRowParams<TRowViewModel>) => params.row.onRowDoubleClick()}
      />
    );
  }
);
